document.addEventListener('DOMContentLoaded', function () {

	const singleProductsThumbs = new Swiper('.webvibe-swiper-thumbs', {
		spaceBetween: 18,
		slidesPerView: 2,
		freeMode: true,
		watchSlidesProgress: true,
		centeredSlides: true,
		centeredSlidesBounds: true,
		breakpoints: {

			1024: {
				slidesPerView: 3,
			},
		}
	});
	var singleProductsMain = new Swiper(".webvibe-swiper-main", {
		spaceBetween: 10,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		thumbs: {
			swiper: singleProductsThumbs,
		},
	})
});


